import React from 'react';
import { Modal } from 'antd';
import RecipientSelector from '../components/RecipientSelector';
import { useLanguage } from '../../../contexts/LanguageContext';

// 收件人選擇模態框
const RecipientModal = ({ 
  visible, 
  onCancel, 
  onSelect, 
  value,
  allowMultiple = true,
  placeholder = '選擇收件人',
  recipientDetails, // 新增：詳細的選擇信息
  workflowDefinitionId // 新增：工作流定義ID
}) => {
  
  const { t } = useLanguage();

  const handleSelect = (selectedValue, detailedValue) => {
    console.log('📤 RecipientModal - 收到選擇值:', selectedValue);
    console.log('📤 RecipientModal - 收到詳細值:', detailedValue);
    onSelect(selectedValue, detailedValue);
    onCancel();
  };

  return (
    <Modal
      title={t('workflowDesigner.selectRecipients')}
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={600}
      zIndex={1050}
      destroyOnHidden
    >
      <RecipientSelector
        value={value}
        onChange={handleSelect}
        placeholder={placeholder}
        allowMultiple={allowMultiple}
        recipientDetails={recipientDetails}
        workflowDefinitionId={workflowDefinitionId}
        t={t}
      />
    </Modal>
  );
};

export default React.memo(RecipientModal);
